import Vue from 'vue'
import VueRouter from 'vue-router'
import Catalogo from '../views/Catalogo.vue'
import ProdutoDetalhes from '../views/ProdutoDetalhes.vue'
import Floricultura from '../views/Floricultura.vue'
import Login from '../views/Login.vue'
import Admin from '../views/Admin.vue'
import Carrinho from '../views/Carrinho.vue'
import Home from '../views/Home.vue'
import Assistente from '../views/Assistente.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/floricultura'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/catalogo',
    name: 'Catalogo',
    component: Catalogo
  },
  {
    path: '/assistente',
    name: 'Assistente',
    component: Assistente
  },
  {
    path: '/floricultura',
    name: 'Floricultura',
    component: Floricultura
  },
  {
    path: '/produto/:id',
    name: 'ProdutoDetalhes',
    component: ProdutoDetalhes
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/carrinho',
    name: 'Carrinho',
    component: Carrinho
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/Checkout.vue')
  },
  {
    path: '/acompanhar-pedido',
    name: 'AcompanharPedido',
    component: () => import('../views/AcompanharPedido.vue')
  },
  {
    path: '/confirmacao/:id?',
    name: 'ConfirmacaoVenda',
    component: () => import('../views/ConfirmacaoVenda.vue')
  },
  {
    path: '/sucesso',
    name: 'Sucesso',
    component: () => import('../views/ConfirmacaoVenda.vue')
  },
  {
    path: '/admin/controle',
    name: 'AdminControle',
    component: () => import('../views/AdminControle.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/venda/:id',
    name: 'VendaDetalhes',
    component: () => import('../views/VendaDetalhes.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash, behavior: 'smooth' }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

// Guard de navegação para rotas protegidas
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router

